import { List } from 'immutable';
import _set from 'lodash/set';
import { all, call, delay, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { getRoutineSaga } from '../common/utils/saga.js';
import { showMessageSaga } from '../messages/saga.js';
import { getCurrentProjectId } from '../project/selectors.js';
import { changeField } from '../schema-form/actions.js';
import { createPublishTarget as createPublishTargetAction, fetchPublishTargets, fetchUser } from './actions.js';
import { createPublishTarget, getPublishTargets, getUser } from './api.js';
import { getIntegrationData } from './selectors.js';

export const showHttpErrorSaga = showMessageSaga('error', (action) => action.payload.message, 5000);

export function* updateTargetFieldSaga({ payload, meta }) {
  const {
    target: { formName, path }
  } = meta;
  yield put(changeField(formName, path)(payload.data.id));
}

export function* ensurePublishTargetThumbnails({ meta: { provider, attempt = 0 } }) {
  // Only try 5 times
  if (attempt >= 5) {
    return;
  }

  // Check if any thumbnails are null
  const integrationData = yield select(getIntegrationData, {
    provider,
    type: 'publishTargets'
  });
  const isMissingThumbs = (integrationData.get('data') || List()).filter((pt) => pt.get('thumb') === null).size;
  // If some are, wait a 1.5 seconds then refetch the sites
  if (isMissingThumbs) {
    yield delay(1500);
    yield put(fetchPublishTargets({ provider, attempt: attempt + 1 }));
  }
}

// If no response, show message in pop up
export function* showRejectedMessage(action) {
  if (!action.payload.response) {
    yield call(showHttpErrorSaga, action);
  }
}

export const withProjectId = (saga) =>
  function* (action) {
    const projectId = yield select(getCurrentProjectId);
    yield* saga(_set(action, 'meta.projectId', projectId));
  };

const fetchUserSaga = getRoutineSaga(fetchUser, getUser, {
  handleBasicErrors: false
});
const fetchPublishTargetsSaga = getRoutineSaga(fetchPublishTargets, getPublishTargets, { handleBasicErrors: false });
const createPublishTargetSaga = getRoutineSaga(createPublishTargetAction, createPublishTarget, {
  handleBasicErrors: false
});

export default function* root() {
  yield all([
    takeEvery(fetchUser.REQUESTED, withProjectId(fetchUserSaga)),
    takeLatest(fetchPublishTargets.REQUESTED, withProjectId(fetchPublishTargetsSaga)),
    takeLatest(createPublishTargetAction.REQUESTED, withProjectId(createPublishTargetSaga)),
    takeLatest([fetchPublishTargets.FULFILLED, createPublishTargetAction.FULFILLED], ensurePublishTargetThumbnails),
    takeLatest(createPublishTargetAction.FULFILLED, updateTargetFieldSaga),
    takeLatest(createPublishTargetAction.REJECTED, showRejectedMessage)
  ]);
}
